import type { RouteRecordRaw } from 'vue-router';
export const ecommerceRoutes: RouteRecordRaw[] = [
  {
    path: 'ecommerce',
    name: 'ecommerce',
    component: () => import('../pages/ecommerce/EcommercePage.vue'),
    meta: { requiresModule: 'ecommerce' },
  },
];
